import { useCallback, useMemo } from "react";
import { useLocalStorageState } from "./useLocalStorageState";
import { flattenAll } from "./searchUtils";
import { MAX_RECENT_ITEMS } from "./constants";

/**
 * Historial de módulos visitados (más reciente primero), por usuario.
 * Igual que favoritos: solo persiste ids, se resuelve contra el árbol vivo.
 */
export function useMenuRecent(idUsuario, tree) {
  const storageKey = `sidebar_recent_${idUsuario || "anon"}`;
  const [recentIds, setRecentIds] = useLocalStorageState(storageKey, []);

  const registerVisit = useCallback(
    (itemId) => {
      setRecentIds((prev) => [itemId, ...prev.filter((id) => id !== itemId)].slice(0, MAX_RECENT_ITEMS));
    },
    [setRecentIds]
  );

  const recentItems = useMemo(() => {
    if (!recentIds.length) return [];
    const byId = new Map(flattenAll(tree).map(({ item }) => [item.id, item]));
    return recentIds.map((id) => byId.get(id)).filter((item) => item && item.route);
  }, [recentIds, tree]);

  return { recentItems, registerVisit };
}
